import React from "react";
import PropTypes from "prop-types";
import Textarea from "react-textarea-autosize";

import _str from "shared/util/_str";

import {
	WINDOW_STATE,
	ENTER_KEY_CODE,
} from "apps/messenger/util/consts";

import "apps/messenger/components/MainWindow/Composer.scss";

class Composer extends React.PureComponent {
	static propTypes = {
		userid: PropTypes.string.isRequired,
		text: PropTypes.string,
		// eslint-disable-next-line react/no-unused-prop-types
		state: PropTypes.oneOf(Object.values(WINDOW_STATE)).isRequired,

		onTextChange: PropTypes.func.isRequired,
		enterToSend: PropTypes.bool,
		sendDisabled: PropTypes.bool.isRequired,
		sendMessage: PropTypes.func.isRequired,
		placeholder: PropTypes.string,
		// eslint-disable-next-line react/no-unused-prop-types
		focusTimeout: PropTypes.number,
	};

	static defaultProps = {
		text: "",
		placeholder: _str("Say something..."),
		enterToSend: false,
		focusTimeout: 0,
	};

	componentDidMount() {
		this._handleFocusLogic(undefined, this.props);
	}

	componentDidUpdate(prevProps) {
		// Makes sure focus is maintained as needed.
		this._handleFocusLogic(prevProps, this.props);
	}

	// Can't use createRef because component doesn't support it...yet.
	_textarea = null;

	_focusTextarea = () => {
		// We need this to focus.
		if (!this._textarea) {
			return;
		}

		this._textarea.focus({ preventScroll: true });
	};

	_handleFocusLogic = (prevProps, nextProps = {}) => {
		// We need this to focus.
		if (!this._textarea) {
			return;
		}

		// First render.
		if (!prevProps) {
			// Focus if window state is open.
			if (nextProps.state === WINDOW_STATE.Open) {
				setTimeout(this._focusTextarea, nextProps.focusTimeout);
			}
		} else {
			const userChanged = prevProps.userid !== nextProps.userid;
			const stateChanged = prevProps.state !== nextProps.state &&
				nextProps.state === WINDOW_STATE.Open;
			const sendTriggerChanged = prevProps.enterToSend !== nextProps.enterToSend;

			// Focus the textarea if we just switched to a new user or just opened the window.
			if (userChanged || stateChanged || sendTriggerChanged) {
				setTimeout(this._focusTextarea, nextProps.focusTimeout);
			}
		}
	};

	_handleKeyDown = (event) => {
		// Ignore anything that's not an enter key.
		// (Unless they have shift pressed, so we can allow multiline messages)
		const enterToSend = this.props.enterToSend &&
			event.keyCode === ENTER_KEY_CODE && !event.shiftKey;
		const metaEnterToSend = event.keyCode === ENTER_KEY_CODE && event.metaKey;

		if (!metaEnterToSend && !enterToSend) {
			return;
		}

		// Enter key pressed.
		event.preventDefault();

		// As long as send isn't disabled...
		if (!this.props.sendDisabled) {
			// Send the message.
			this.props.sendMessage(this.props.userid);
		}
	};

	_handleChange = (event) => {
		const { onTextChange } = this.props;

		onTextChange(event.target.value);
	};

	render() {
		const isMinimized = this.props.state === WINDOW_STATE.Minimized;

		return (
			<div className="messenger-composer-wrapper">
				<Textarea
					inputRef={(ref) => { this._textarea = ref; }}
					className="messenger-composer"
					placeholder={this.props.placeholder}
					value={this.props.text}
					onInput={this._handleChange}
					onKeyDown={this._handleKeyDown}
					disabled={isMinimized}
				/>
			</div>
		);
	}
}

export default Composer;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/MainWindow/Composer.jsx